<script lang="ts" setup>
const props = defineProps<{
  data: Array<{
    id: string
    image: string
    head: string
    description: string
  }>
  title: string
}>()
</script>

<template>
  <div>
    <div
      class="tracking-wider flex justify-center text-2xl !mb-6 text-center px-2.5 leading-10 lg:text-[1.75rem] lg:mb-18 lg:px-0"
    >
      {{ title }}
    </div>
    <div class="mt-6.5 mx-5 gap-7.5 flex flex-col lg:mx-0">
      <div
        v-for="item in data"
        :key="item.id"
        class="flex flex-col items-center lg:flex-row lg:justify-center"
      >
        <img class="w-18.25 h-16.5" :alt="item.head" :src="item.image" />
        <div class="mt-2.5 lg:ml-7 lg:max-w-176 lg:w-full">
          <div
            class="why-choose-belong-item-name text-2xl font-medium tracking-wide text-center text-[#FFB0F0] lg:text-left lg:text-[1.375rem]"
          >
            {{ item.head }}
          </div>
          <div
            class="text-lg tracking-wide text-[#CECECE] mt-2.5 text-center lg:text-left"
          >
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
